import type { FC } from 'react';
import { useMemo } from 'react';
import { Box, useTheme } from '@mui/material';

import { styles } from '../table.styles';

interface NpsScoreProps {
  score: number;
}

const NpsScore: FC<NpsScoreProps> = ({ score }) => {
  const theme = useTheme();
  const { color, backgroundColor } = useMemo(() => {
    if (score > 8)
      return {
        color: theme.colors.success[700],
        backgroundColor: theme.colors.success[50],
      };
    if (score > 6)
      return {
        color: theme.colors.neutral[600],
        backgroundColor: theme.colors.neutral[50],
      };
    return {
      color: theme.colors.error[800],
      backgroundColor: theme.colors.error[50],
    };
  }, [score]);

  return (
    <Box
      component="span"
      sx={{
        ...styles.npsScore,
        backgroundColor,
        color,
      }}
    >
      {score}
    </Box>
  );
};

export default NpsScore;
